const doc = [({"en":({"js":({"merfoto":({"order_deliveries":({"delivery_methods":({"pick_up":({"index":({"pick_up":"Pick up"})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;